/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import shortid from 'shortid'
import { Link } from 'react-router-dom'

import Button from '../../lib/components/Button'
import Tooltip, { withTooltip } from '../../lib/components/Tooltip'
import Typography from '../../lib/typography'
import { momentFormatter } from '../../lib/utils'

import { SPACING as constants } from '../../constants'
import { SUBMIT_STATUS } from '../../pages/project-profit-sheet/constants'
import { PATH as INFO_PATH, HEADER as INFO_HEADER } from '../../pages/project-information/constants'
import InfoButton from '../../static/images/rounded-info-button.svg'

const WORD_COLOR_MAPPING = {
  UNSUBMIT: 'grey',
  SUBMIT: 'green',
}

const Layout = {
  Container: styled.div`
    width: 100%;
    min-height: 92px;
    padding: 8px ${constants.GAP} 0;

    position: relative;
    z-index: 10;

    background-color: #fff;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);

    display: flex;
    flex-wrap: wrap;
    align-content: space-around;

    > :last-child {
      margin-bottom: 8px;
    }
  `,
  DataFields: styled.div`
    max-width: calc(100% - 111px);
    margin-right: -24px;

    display: flex;
    flex-wrap: wrap;
    align-content: space-around;

    > * {
      margin-right: 24px;
      margin-bottom: 8px;
    }
  `,
  Field: styled.div`
    display: flex;
    flex-direction: column;

    ${withTooltip}

    > :not(:last-child) {
      margin-bottom: 5px;
    }

    &:hover ${Tooltip} {
      transition-delay: 1s;
    }
  `,
  Menu: styled.div`
    width: 100%;
    display: flex;
  `,
}

const Unapproved = {
  Icon: styled.i`
    width: 12px;
    height: 12px;
    display: inline-block;

    position: relative;
    top: 1px;

    background-image: url(${InfoButton});

    cursor: pointer;
  `,
}

/**
 * @param {object} props
 * @param {string} props.projectId
 * @param {string} props.status
 * @param {string} props.code
 * @param {string} props.client
 * @param {string} props.description
 * @param {string} props.lob
 * @param {string} props.start
 * @param {string} props.end
 * @param {string} props.submit
 * @param {boolean} props.projectInfoEnabled
 * @param {object[]} props.unapproved_users
 * @param {() => void} props.onInfoClick
 * @param {React.ReactNode} props.children
 */
function StatusBar(props) {
  return (
    <Layout.Container>
      <Layout.DataFields>
        <Layout.Field>
          <Typography.Caption>Status</Typography.Caption>
          <Typography.Data disc={ WORD_COLOR_MAPPING[props.status] }>
            {SUBMIT_STATUS[props.status]}
          </Typography.Data>
        </Layout.Field>
        <Layout.Field>
          <Typography.Caption>Project Code</Typography.Caption>
          <Typography.Data style={ { width: 100, marginBottom: 0 } }>
            {props.code}
          </Typography.Data>
          <Tooltip>{props.code}</Tooltip>
        </Layout.Field>
        <Layout.Field>
          <Typography.Caption>Client</Typography.Caption>
          <Typography.Data style={ { width: 100, marginBottom: 0 } }>
            {props.client}
          </Typography.Data>
          <Tooltip>{props.client}</Tooltip>
        </Layout.Field>
        <Layout.Field>
          <Typography.Caption>Project Name</Typography.Caption>
          <Typography.Data style={ { width: 150, marginBottom: 0 } }>
            {props.project_name}
          </Typography.Data>
          <Tooltip>{props.project_name}</Tooltip>
        </Layout.Field>
        <Layout.Field>
          <Typography.Caption>LOB</Typography.Caption>
          <Typography.Data>{props.lob}</Typography.Data>
        </Layout.Field>
        <Layout.Field>
          <Typography.Caption>Key PM</Typography.Caption>
          <Typography.Data style={ { width: 100, marginBottom: 0 } }>
            {props.key_project_manager}
          </Typography.Data>
          <Tooltip>{props.key_project_manager}</Tooltip>
        </Layout.Field>
        <Layout.Field>
          <Typography.Caption>Start Date</Typography.Caption>
          <Typography.Data>{momentFormatter('DD/MM/YYYY')(props.start)}</Typography.Data>
        </Layout.Field>
        <Layout.Field>
          <Typography.Caption>End Date</Typography.Caption>
          <Typography.Data>{momentFormatter('DD/MM/YYYY')(props.end)}</Typography.Data>
        </Layout.Field>
        <Layout.Field>
          <Typography.Caption>Submitted Date</Typography.Caption>
          <Typography.Data>{momentFormatter('DD/MM/YYYY')(props.submit)}</Typography.Data>
        </Layout.Field>
        <Layout.Field>
          <Typography.Caption>Unapproved Timesheets</Typography.Caption>
          <Typography.Data style={ { overflow: 'visible' } }>
            {props.unapproved_users.length} <Unapproved.Icon />
          </Typography.Data>
          <Tooltip>
            {props.unapproved_users.map(u => (
              <div key={ shortid.generate() } style={ { display: 'block', fontStyle: 'normal' } }>
                ({u.nick_name}) {u.first_name}
              </div>
            ))}
          </Tooltip>
        </Layout.Field>
      </Layout.DataFields>
      {props.projectInfoEnabled && (
        <Link
          style={ { marginLeft: 'auto' } }
          to={
            {
              pathname: `${INFO_PATH}/${props.projectId}`,
              state: {
                header: INFO_HEADER,
              },
            }
          }
        >
          <Button color="danger">
          Project Info
          </Button>
        </Link>
      )}
      <Layout.Menu>{props.children}</Layout.Menu>
    </Layout.Container>
  )
}

export default StatusBar



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/StatusBar.jsx